import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Row, Typography, Form, Input, Button, Checkbox, Select, Rate, Modal, Popover, Skeleton, Tag } from "antd";
import { FaChevronDown, FaChevronUp, FaInfoCircle, FaMapMarkedAlt, FaPhone, FaRegEnvelope } from "react-icons/fa";
import { useLocation, Link } from "react-router-dom";
import moment from "moment";
import { fetchHotelReviewTripjack, gethotelbookTripjack } from "../../../services/hotel/hotelServices";
import { flightLoader } from "../../../utils/ImagePath";
import CancellationPolicyHotel from "../PaymentHotelpage/CancellationPolicyHotel";
import { formatDate } from "../../../utils/Constants";
import HotelOffers from "../PaymentHotelpage/HotelOffers";
import HotelOffersMobile from "../PaymentHotelpage/HotelOffersMobile";
import FilteredInput from "../../../layout/FilteredInput";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
const { TextArea } = Input;
const { Title, Text } = Typography;

const HotelPaymentTripjack = () => {

    const [bookingLoader, setBookingLoader] = useState(null);
    const [bookingMessage, setBookingMessage] = useState(null);
    const [bookingMessageError, setBookingMessageError] = useState(null);
    const [checked, setChecked] = useState(false);
    const location = useLocation();
    const { Option } = Select;
    const { openRoomDetailsUpdate, hotelDetails } = location.state || {};
    const [phone, setPhone] = useState("");
    const [isValid, setIsValid] = useState(false);
    const [isValidReq, setIsValidReq] = useState(false);
    const totalNights = JSON.parse(localStorage.getItem("night"));
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [roomInfo, setRoomInfo] = useState(null);
    const [loading, setLoading] = useState(null);
    const [hotelReviewTripjack, setHotelReviewTripjack] = useState(null);


    useEffect(() => {
        const fetchHotelDetails = async () => {
            const storedStartDate = localStorage.getItem('startDate');
            const storedEndDate = localStorage.getItem('endDate');
            const storedRoomInfo = localStorage.getItem('roomInfo');

            if (storedStartDate) {
                const formattedStartDate = moment(storedStartDate, [
                    'MMM DD, YYYY',
                    'YYYY-MM-DD',
                ]).format('MMM DD, YYYY');
                setStartDate(formattedStartDate);
            }

            if (storedEndDate) {
                const formattedEndDate = moment(storedEndDate, [
                    'MMM DD, YYYY',
                    'YYYY-MM-DD',
                ]).format('MMM DD, YYYY');
                setEndDate(formattedEndDate);
            }

            if (storedRoomInfo) setRoomInfo(JSON.parse(storedRoomInfo));

            try {
                setLoading(true);
                const payload = {
                    hotelId: hotelDetails?.id,
                    optionId: openRoomDetailsUpdate?.id,
                };
                const resp = await fetchHotelReviewTripjack(payload);
                setHotelReviewTripjack(resp.data);
            } catch (error) {
                console.error('Error fetching hotel details:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchHotelDetails();
    }, [hotelDetails?.id, openRoomDetailsUpdate?.id]);

    const [phoneValue, setPhoneValue] = useState('');
    const [countryCode, setCountryCode] = useState(null)
    const validatePhone = (_, value) => {
        if (!value || value.trim() === "" || value === "+91") {
            return Promise.reject(new Error("Mobile number is required"));
        }
        const phoneNumber = parsePhoneNumberFromString(countryCode);
        if (!phoneNumber || !phoneNumber.isValid()) {
            return Promise.reject(new Error("Enter a valid mobile number"));
        }
        return Promise.resolve();
    };

    const handlePhoneChange = (value) => {
        setCountryCode(value)
        const sanitized = value.replace("+91", "").trim();
        setPhoneValue(sanitized);
        form.setFieldsValue({ contacts: sanitized });
    };

    const nights = parseInt(totalNights);

    const totalNOAdults = roomInfo?.reduce(
        (total, room) => total + room.numberOfAdults,
        0
    );
    const totalNOChildren = roomInfo?.reduce(
        (total, room) => total + room.numberOfChild,
        0
    );

    const totalRooms = roomInfo?.length;
    const [form] = Form.useForm();



    const [open, setOpen] = useState(false);
    const handleOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    const onChange = (e) => {
        setChecked(e.target.checked);
    };

    let getUser = JSON.parse(localStorage.getItem("user"));
    const [appliedCheckLogin, setAppliedCheckLogin] = useState("");
    const [applyDiscountShow, setApplyDiscountShow] = useState(false);
    const [isCongratulations, setIsCongratulations] = useState(null);
    const [isValidCoupon, setValidCoupon] = useState(null);
    const [couponId, setCouponId] = useState(null);



    const applyValidCoupon = (couponIdVal, discount, totalAfter) => {
        setCouponId(couponIdVal);
        setDiscountAmountOffer(discount);
        setTotalAfterDiscount(totalAfter);
        setApplyDiscountShow(true);
        setIsCongratulations(true);
        setValidCoupon(null);
    };

    const applyInvalidCoupon = (message) => {
        setCouponId(null);
        setApplyDiscountShow(false);
        setIsCongratulations(false);
        setValidCoupon(message);
    };

    const applyDiscount = () => {
        const user = JSON.parse(localStorage.getItem("user")) || {};
        const userRewardPoints = user?.reward_point || 0;
        const totalAmount = Math.round(hotelReviewTripjack?.hInfo?.ops?.[0]?.totalFare || 0);

        if (!appliedCheckLogin) return;

        const { type, discountType, discount = 0, id } = appliedCheckLogin;

        let discountAmount = 0;
        let totalAfterDiscount = totalAmount;

        if (discountType === "PERCENTAGE") {
            discountAmount = (totalAmount * discount) / 100;
        } else if (discountType === "AMOUNT") {
            discountAmount = discount;
        }

        if (type === "CASHBACK_OFFER") {
            if (discountAmount < userRewardPoints) {
                totalAfterDiscount = totalAmount - discountAmount;
                applyValidCoupon(id, discountAmount, totalAfterDiscount);
            } else {
                applyInvalidCoupon("We’re sorry, but it seems your account balance is insufficient to redeem this coupon.");
            }
        } else {
            totalAfterDiscount = totalAmount - discountAmount;
            applyValidCoupon(id, discountAmount, totalAfterDiscount);
        }
    };

    const [discountAmountOffer, setDiscountAmountOffer] = useState(0);
    const [totalAfterDiscount, setTotalAfterDiscount] = useState(0);
    const paymentData = hotelReviewTripjack?.hInfo?.ops?.[0];
    const isLoading = loading || !paymentData;
    const baseFare = paymentData?.TotalPublishFare;
    const discount = applyDiscountShow ? discountAmountOffer : paymentData?.discountAmount;
    const publishedPrice = applyDiscountShow ? baseFare - discountAmountOffer : paymentData?.PublishedPriceRoundedOff;
    const serviceTax = paymentData?.ServiceTax;
    const totalAmount = applyDiscountShow ? publishedPrice + serviceTax : paymentData?.totalFare;

    const onFinishFailed = () => {
        setTimeout(() => {
            const errorElements = document.querySelectorAll(".ant-form-item-has-error");

            if (errorElements.length > 0) {
                const firstError = errorElements[0];
                const collapsePanel = firstError.closest(".ant-collapse-item");
                if (collapsePanel) {
                    const panelKey = collapsePanel.getAttribute("data-panel-key");
                    if (panelKey && !activeKeys.includes(panelKey)) {
                        setActiveKeys((prev) => [...prev, panelKey]);
                    }
                }

                const elementRect = firstError.getBoundingClientRect();
                const absoluteElementTop = elementRect.top + window.pageYOffset;
                const offset = 120; // adjust if header present
                const scrollToPosition = absoluteElementTop - offset;

                window.scrollTo({
                    top: scrollToPosition,
                    behavior: "smooth",
                });
            }
        }, 100);
    };
    const onFinishBook = async (values) => {
        setBookingLoader(true);
        const hotelPassengers = [];
        const prepareAdultPassengers = (room, roomIndex, values) => {
            return Array.from({ length: room?.numberOfAdults }).map(
                (_, adultIndex) => ({
                    ti: values[`room-${roomIndex}-adult-${adultIndex}-title`],
                    fN: values[`room-${roomIndex}-adult-${adultIndex}-firstName`],
                    lN: values[`room-${roomIndex}-adult-${adultIndex}-lastName`],
                    pan_number: values[`room-${roomIndex}-adult-${adultIndex}-pan_number`],
                    passport_number: values[`room-${roomIndex}-adult-${adultIndex}-passport_number`],
                    pt: "ADULT",
                })
            );
        };

        const prepareChildPassengers = (room, roomIndex, values) => {
            return Array.from({ length: room?.numberOfChild }).map(
                (_, childIndex) => ({
                    ti: values[`room-${roomIndex}-child-${childIndex}-title`],
                    fN: values[`room-${roomIndex}-child-${childIndex}-firstName`],
                    lN: values[`room-${roomIndex}-child-${childIndex}-lastName`],
                    pt: "CHILD",
                })
            );
        };
        roomInfo.forEach((room, roomIndex) => {
            hotelPassengers.push(
                ...prepareAdultPassengers(room, roomIndex, values),
                ...prepareChildPassengers(room, roomIndex, values)
            );
        });

        const payload = {
            ...(couponId != null ? { coupon_id: Number(couponId) } : {}),
            ...(getUser?.id ? { user_id: Number(getUser.id) } : {}),
            bookingId: hotelReviewTripjack?.bookingId,
            hotelId: hotelDetails?.id,
            optionId: openRoomDetailsUpdate?.id,
            roomTravellerInfo: roomInfo.map((room, roomIndex) => ({
                travellerInfo: [
                    ...prepareAdultPassengers(room, roomIndex, values),
                    ...prepareChildPassengers(room, roomIndex, values),
                ],
            })),
            deliveryInfo: {
                emails: [values?.email],
                contacts: [countryCode],
                billing_address: values?.billing_address?.toString() || "",
            },
            type: hotelReviewTripjack?.hInfo?.pt,
            paymentInfos: [{ "amount": totalAmount }]
        };

        try {
            const response = await gethotelbookTripjack(payload);
            setBookingLoader(false);
            window.location.href = response.data?.paymentResponse?.payment_links?.web;
        } catch (apiError) {
            const errorMessage = apiError?.response?.data?.message;
            setBookingMessageError(true);
            setBookingMessage(errorMessage);
        }
    };



    const [isOpen, setIsOpen] = useState(false);
    const [isOpenPayment, setIsOpenPayment] = useState(false);

    const togglePolicy = () => {
        setIsOpen((prev) => !prev);
    };
    const togglePayment = () => {
        setIsOpenPayment((prev) => !prev);
    };

    return (
        <>
            <section className="container hotel_payment mb-4">
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinishBook}
                    onFinishFailed={onFinishFailed}
                >
                    <Row gutter={16} className="mt-md-5 mt-4">
                        <Col md={16} xs={24}>
                            <Card className="hotel-card mb-2">
                                <Title level={3} className="mb-2 fw-bold mb-md-4">
                                    Property Information
                                </Title>
                                <Row gutter={16} className="hotel-details">
                                    <Col md={8} xs={24} className="d-none">
                                        <img
                                            src={openRoomDetailsUpdate?.ris?.[0]?.imgs?.[0]?.url}
                                            className="img-fluid rounded object-cover"
                                        />
                                    </Col>
                                    <Col md={16} xs={24}>
                                        <div className="d-flex align-items-center mb-1">
                                            <ul className="d-flex align-items-center gap-1 p-0 m-0">
                                                <Rate disabled value={hotelDetails?.hotel?.rt} />
                                            </ul>
                                            <span className="ms-2">{hotelDetails?.hotel?.pt}</span>
                                        </div>
                                        <Title level={4} className="fw-bold mb-0"> {hotelDetails?.hotel?.name} </Title>
                                        <Title level={5} className="m-0 mb-2 fw-bold">
                                            <FaMapMarkedAlt className="me-1" /> Location Information
                                        </Title>
                                        <ul className="hotel-services list-unstyled">
                                            <li className="mb-2">
                                                <FaMapMarkedAlt className="me-2" />
                                                {hotelDetails?.hotel?.ad?.adr}, {hotelDetails?.hotel?.ad?.adr2}
                                            </li>

                                            {hotelReviewTripjack?.hInfo?.cnt?.ph && (
                                                <li>
                                                    <FaPhone className="me-2" />
                                                    {hotelReviewTripjack?.hInfo?.cnt?.ph}
                                                </li>
                                            )}
                                        </ul>

                                    </Col>
                                </Row>
                            </Card>

                            <Card className="card mb-md-2 booking_details">
                                <div>
                                    <Title level={3} className="mb-2 fw-bold mb-md-4">
                                        Your Booking Details
                                    </Title>
                                    <div className="d-flex align-items-center justify-content-between gap-3 mb-3 mb-md-4">
                                        <div className="booking_box bg-light-success">
                                            <Title level={5} className="mb-0 fw-bold">
                                                Check-in
                                            </Title>
                                            <p>
                                                {formatDate(startDate)}
                                            </p>
                                        </div>
                                        <div className="booking_box bg-light-danger">
                                            <Title level={5} className="mb-0 fw-bold">
                                                Check-out
                                            </Title>
                                            <p>
                                                {formatDate(endDate)}
                                            </p>
                                        </div>
                                    </div>
                                    <ul className="Hotel_services">
                                        <li>
                                            You Will Stay {nights} Night{nights > 1 ? "s" : ""}{" "}
                                        </li>
                                        <li>You Selected {totalRooms} Rooms For :</li>
                                        <li>{totalNOAdults} Adults</li>
                                        {/* <li>{totalNOChildren} Children (12 ,7 and 5 Years Old)</li> */}
                                        <li>{totalNOChildren} Children</li>
                                    </ul>
                                </div>
                            </Card>

                            <Card className="card mb-md-2 payment_details">
                                <div>
                                    <Title
                                        level={4}
                                        className="fw-bold mb-0 d-flex align-items-center justify-content-between"
                                        style={{ cursor: "pointer" }}
                                        onClick={togglePolicy}
                                    >
                                        Cancellation Policy
                                        {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                                    </Title>
                                    {isOpen && (
                                        <div>
                                            {openRoomDetailsUpdate?.cnp ? (
                                                <div className="cancellation-policy-container">
                                                    <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
                                                        {openRoomDetailsUpdate?.cnp?.pd?.some(p => p.am === 0) ? (
                                                            <Tag color="green" className="text-uppercase fw-medium">
                                                                Refundable
                                                            </Tag>
                                                        ) : (
                                                            <Tag color="red" className="text-uppercase fw-medium">
                                                                Non-Refundable
                                                            </Tag>
                                                        )}

                                                        {openRoomDetailsUpdate?.cnp.ifra && (
                                                            <Tag color="blue" className="text-uppercase fw-medium">
                                                                Free Cancellation Available
                                                            </Tag>
                                                        )}

                                                    </div>

                                                    <div className="policy-timeline d-none">
                                                        {openRoomDetailsUpdate?.cnp.pd.map((period, index) => (
                                                            <div key={index} className="policy-period mb-3 p-3 rounded border shadow-sm">
                                                                <div className="d-flex justify-content-between flex-wrap">
                                                                    <div className="text-muted mb-2">
                                                                        <Text strong>From:</Text>{' '}
                                                                        {moment(period.fdt).format('MMM DD, YYYY hh:mm A')}
                                                                        {' → '}
                                                                        <Text strong>To:</Text>{' '}
                                                                        {moment(period.tdt).format('MMM DD, YYYY hh:mm A')}
                                                                    </div>

                                                                    <div>
                                                                        <Text className="text-dark fw-bold">
                                                                            {period.am ? `₹${period.am.toFixed(2)}` : 'No charge'}
                                                                        </Text>
                                                                        {period.pp && (
                                                                            <Text type="secondary" className="ms-2">
                                                                                ({period.pp}% of total)
                                                                            </Text>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {openRoomDetailsUpdate?.cnp?.pd?.some(p => p.am === 0) ? (
                                                        (() => {
                                                            const pd = openRoomDetailsUpdate.cnp.pd;
                                                            const first = pd[0];
                                                            const second = pd[1];
                                                            const last = pd[pd.length - 1];

                                                            return (
                                                                <div className="mb-4">
                                                                    <div className="refund-timeline">
                                                                        <div className="timeline-segment left-segment">
                                                                            <div className="circle">
                                                                                <div className="tooltip">
                                                                                    <strong>From:</strong> {moment(first.fdt).format('MMM DD, YYYY hh:mm A')}<br />
                                                                                    <strong>To:</strong> {moment(first.tdt).format('MMM DD, YYYY hh:mm A')}<br />
                                                                                    <span className="mt-1 d-inline-block">
                                                                                        <strong>Charge:</strong> ₹{first.am?.toFixed(2) || 0}
                                                                                        {first.pp ? <> ({first.pp}% of total)</> : null}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="label-top">100% Refund</div>
                                                                            <div className="label-bottom">
                                                                                <strong>NOW</strong>
                                                                            </div>
                                                                        </div>
                                                                        <div className="timeline-center">
                                                                            <div className="center-line"></div>
                                                                            <div className="center-date">
                                                                                <strong>{moment(second.fdt).format('DD MMM')}</strong><br />
                                                                                {moment(second.fdt).format('hh:mm A')}
                                                                            </div>
                                                                        </div>
                                                                        <div className="timeline-segment right-segment">
                                                                            <div className="circle">
                                                                                <div className="tooltip">
                                                                                    <strong>From:</strong> {moment(second.fdt).format('MMM DD, YYYY hh:mm A')}<br />
                                                                                    <strong>To:</strong> {moment(last.tdt).format('MMM DD, YYYY hh:mm A')}<br />
                                                                                    <span className="mt-1 d-inline-block">
                                                                                        <strong>Charge:</strong> ₹{last.am?.toFixed(2) || 0}
                                                                                        {last.pp ? <> ({last.pp}% of total)</> : null}
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="label-top label-yellow">Non Refundable</div>
                                                                            <div className="label-bottom">
                                                                                <strong>{moment(last.tdt).format('DD MMM')}</strong><br />
                                                                                <span className="small">Check-in</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })()
                                                    ) : (
                                                        <div className="non-refundable-text fw-medium">
                                                            No refund available for this booking
                                                        </div>
                                                    )}

                                                </div>
                                            ) : (
                                                <Text type="secondary">No cancellation policy information available.</Text>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </Card>

                            <div className="card d-md-none">
                                <div className="card-body">
                                    <>
                                        {/* <h3 className="mb-3 fw-bold"></h3> */}
                                        <h3
                                            className="fw-bold mb-0 d-flex align-items-center justify-content-between"
                                            style={{ cursor: "pointer" }}
                                            onClick={togglePayment}
                                        >
                                            Payment Detail
                                            {isOpenPayment ? <FaChevronUp /> : <FaChevronDown />}
                                        </h3>

                                        {isOpenPayment && (
                                            <div>
                                                {isLoading ? (
                                                    <div className="pt-3 pb-4">
                                                        <Skeleton active paragraph={{ rows: 4 }} title={false} />
                                                        <div className="text-center mt-3 bg-light p-2 rounded">
                                                            <h4 className="text-muted">Updating price details...</h4>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="d-flex align-items-center justify-content-between mt-3">
                                                            <Text>
                                                                Base Fare * {nights} Night{nights > 1 ? 's' : ''}
                                                            </Text>
                                                            <Text>
                                                                <b>₹{baseFare} /-</b>
                                                            </Text>
                                                        </div>

                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <Text>{applyDiscountShow ? 'Discount' : 'Total Discount'}</Text>
                                                            <Text>
                                                                <b>
                                                                    <span className="text-danger">₹{discount}</span> /-
                                                                </b>
                                                            </Text>
                                                        </div>

                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <Text>Price after Discount</Text>
                                                            <Text>
                                                                <b>₹{publishedPrice} /-</b>
                                                            </Text>
                                                        </div>

                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <Text>Taxes & Fees</Text>
                                                            <Text>
                                                                <b>₹{serviceTax} /-</b>
                                                            </Text>
                                                        </div>

                                                        <div className="text-center mt-3 bg-light-success p-2 rounded">
                                                            <h3 className="d-flex justify-content-between">
                                                                Total: <span className="fw-bold">₹{totalAmount}</span>
                                                            </h3>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        )}


                                    </>
                                </div>
                            </div>

                            <Card className="card mb-md-2 Edit_Profile">
                                <Title level={4} className="fw-bold m-0 mb-3">
                                    Guest Details
                                </Title>

                                {roomInfo?.map((room, roomIndex) => (
                                    <div key={`room-${roomIndex}`} className="">
                                        {/* <h3 className="mb-2">Room {roomIndex + 1}  Adult{ room?.numberOfAdults}  Child{ room?.numberOfChild}</h3> */}
                                        <h3 className="mb-3 fw-semibold">
                                            Room {roomIndex + 1}{' '}
                                            <span className="mx-2">|</span>
                                            <span className="text-muted">Adults: {room?.numberOfAdults}</span>
                                            <span className="mx-2">|</span>
                                            <span className="text-muted">Children: {room?.numberOfChild}</span>
                                        </h3>

                                        {Array.from({ length: room?.numberOfAdults }).map(
                                            (_, adultIndex) => (
                                                <Row gutter={16}
                                                    key={`room-${roomIndex}-adult-${adultIndex}`}
                                                >
                                                    <Col md={3} xs={24}>
                                                        <Form.Item
                                                            name={`room-${roomIndex}-adult-${adultIndex}-title`}
                                                            // label={`Adult ${adultIndex + 1} - Title`}
                                                            label={`Title`}
                                                            initialValue="Mr"
                                                        >
                                                            <Select
                                                                className="from-control"
                                                            >
                                                                <Option value="Mr">Mr</Option>
                                                                <Option value="Mrs">Mrs</Option>
                                                                <Option value="Ms">Ms</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={7} xs={24}>
                                                        <Form.Item
                                                            name={`room-${roomIndex}-adult-${adultIndex}-firstName`}
                                                            label="First Name"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "First Name is required!",
                                                                },
                                                            ]}
                                                        >
                                                            <FilteredInput
                                                                className="from-control"
                                                                placeholder="First Name"
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={7} xs={24}>
                                                        <Form.Item
                                                            name={`room-${roomIndex}-adult-${adultIndex}-lastName`}
                                                            label="Last Name"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Last Name is required!",
                                                                },
                                                            ]}
                                                        >
                                                            <FilteredInput
                                                                className="from-control"
                                                                placeholder="Last Name"
                                                            />
                                                        </Form.Item>
                                                    </Col>

                                                    {hotelDetails?.hotel?.ops[0]?.ipr &&
                                                        <Col md={7} xs={24}>
                                                            <Form.Item
                                                                name={`room-${roomIndex}-adult-${adultIndex}-pan_number`}
                                                                label="PAN Number"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "PAN number is required!",
                                                                    },
                                                                    {
                                                                        pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                                                                        message: "Enter a valid PAN number (e.g. ABCDE1234F)",
                                                                    },
                                                                ]}
                                                            >
                                                                <FilteredInput
                                                                    className="from-control"
                                                                    placeholder="Pan Number"
                                                                    // style={{ textTransform: 'uppercase' }}
                                                                    onChange={(e) => {
                                                                        const upperValue = e.target.value.toUpperCase();
                                                                        form.setFieldsValue({
                                                                            [`room-${roomIndex}-adult-${adultIndex}-pan_number`]: upperValue,
                                                                        });
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    }

                                                    {hotelDetails?.hotel?.ops[0]?.ipm &&
                                                        <Col md={7} xs={24}>
                                                            <Form.Item
                                                                name={`room-${roomIndex}-adult-${adultIndex}-passport_number`}
                                                                label="Passport Number"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message: "Passport Number is required!",
                                                                    },
                                                                    {
                                                                        pattern: /^[A-PR-WY][0-9]{7}$/,
                                                                        message: "Enter a valid Passport Number (e.g. K1234567)",
                                                                    },
                                                                ]}
                                                            >
                                                                <FilteredInput
                                                                    className="from-control"
                                                                    placeholder="Passport Number"
                                                                    onChange={(e) => {
                                                                        const upperValue = e.target.value.toUpperCase();
                                                                        form.setFieldsValue({
                                                                            [`room-${roomIndex}-adult-${adultIndex}-passport_number`]: upperValue,
                                                                        });
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    }
                                                </Row>
                                            )
                                        )}

                                        {Array.from({ length: room?.numberOfChild }).map(
                                            (_, childIndex) => (
                                                <Row
                                                    gutter={16}
                                                    key={`room-${roomIndex}-child-${childIndex}`}
                                                >
                                                    <Col md={6} xs={24} className="mb-3">
                                                        <Form.Item
                                                            name={`room-${roomIndex}-child-${childIndex}-title`}
                                                            // label={`Child ${childIndex + 1} - Title`}
                                                            label={`Title`}
                                                            initialValue="Master"
                                                        >
                                                            <Select
                                                                className="from-control"
                                                            >
                                                                <Option value="Master">Master</Option>
                                                                <Option value="Miss">Miss</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>

                                                    <Col md={9} xs={24} className="mb-3">
                                                        <Form.Item
                                                            name={`room-${roomIndex}-child-${childIndex}-firstName`}
                                                            label={`First Name (Age: ${room?.childAge[childIndex]}Y)`}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "First Name is required!",
                                                                },
                                                            ]}
                                                        >
                                                            <FilteredInput
                                                                className="from-control"
                                                                placeholder="First Name"
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={9} xs={24} className="mb-3">
                                                        <Form.Item
                                                            name={`room-${roomIndex}-child-${childIndex}-lastName`}
                                                            label="Last Name"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: "Last Name is required!",
                                                                },
                                                            ]}
                                                        >
                                                            <FilteredInput
                                                                className="from-control"
                                                                placeholder="Last Name"
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            )
                                        )}

                                    </div>
                                ))}
                            </Card>

                            <Card className="mb-md-0 mb-5 traveller-details">
                                <Row gutter={16}>
                                    <Col md={12} className='w-100 mb-1'>
                                        <Form.Item
                                            name="contacts"
                                            label="Mobile Number"
                                            rules={[
                                                {
                                                    required: true,
                                                    validator: validatePhone,
                                                },
                                            ]}
                                            validateTrigger={['onSubmit']}
                                        >

                                            <PhoneInput
                                                defaultCountry={'in'}
                                                forceDialCode={true}
                                                disableDialCodeAndPrefix={true}
                                                showDisabledDialCodeAndPrefix={true}
                                                placeholder="Enter Mobile Number"
                                                className="w-100 custom-phone-inputs"
                                                disableFormatting={true}
                                                value={phoneValue}
                                                onChange={handlePhoneChange}

                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col md={12} className='w-100 mb-1'>
                                        <Form.Item
                                            name="email"
                                            label="Email"
                                            className="pulse_input"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Email  is required",
                                                },
                                                {
                                                    type: 'email',
                                                    message: "Please enter a valid email address",
                                                }
                                            ]}
                                            validateTrigger={['onBlur']}
                                        >
                                            <Input
                                                placeholder='Enter your Email'
                                                prefix={<FaRegEnvelope className="me-2" />}
                                            />
                                            {/* <span className='d-flex justify-content-between align-items-center'>Your ticket will be sent to this email address</span> */}
                                        </Form.Item>


                                    </Col>

                                    <Col md={24} className='w-100 mb-1'>
                                        <Form.Item
                                            name="billing_address"
                                            label="Billing Address"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Billing Address is required",
                                                },
                                            ]}
                                        >

                                            <TextArea
                                                placeholder="Enter your billing address"
                                                rows={2}
                                                style={{ height: 'auto', }}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} className="traveller-details">
                                        <Title level={5} className='fw-bold mb-2'><Checkbox onChange={onChange} className='me-3 me-md-2' /> Enter GST Details (Optional)</Title>

                                        {checked &&
                                            <div className="mb-2">
                                                <Row gutter={16}>
                                                    <Col md={8} xs={24}>
                                                        <Form.Item
                                                            name="gstNumber"
                                                            label="GST Number"
                                                            rules={[{ required: true, message: 'Please enter GST Number' }]}
                                                        >
                                                            <FilteredInput placeholder="Enter GST Number" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={8} xs={24}>
                                                        <Form.Item
                                                            name="companyName"
                                                            label="Company Name"
                                                            rules={[{ required: true, message: 'Please enter Company Name' }]}
                                                        >
                                                            <FilteredInput placeholder="Enter Company Name" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={8} xs={24}>
                                                        <Form.Item
                                                            name="businessEmail"
                                                            label="Business Email ID"
                                                            rules={[{ required: true, message: 'Please enter Business Email ID' }, { type: 'email', message: 'Please enter a valid email' }]}
                                                        >
                                                            <FilteredInput placeholder="Enter Business Email ID" prefix={<FaRegEnvelope />} />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row gutter={16}>
                                                    <Col md={8} xs={24}>
                                                        <Form.Item
                                                            name="mobile"
                                                            label="Mobile Number"
                                                            rules={[{ required: true, message: 'Please enter Mobile Number' }]}
                                                        >
                                                            <FilteredInput placeholder="Enter Mobile Number" />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col md={16} xs={24}>
                                                        <Form.Item
                                                            name="companyAddress"
                                                            label="Company Address"
                                                            rules={[{ required: true, message: 'Please enter Company Address' }]}
                                                        >
                                                            <FilteredInput placeholder="Enter Company Address" />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </div>
                                        }

                                        <Form.Item
                                            name="agree"
                                            valuePropName="checked"
                                            className="mb-0"
                                            rules={[
                                                {
                                                    validator: (_, value) =>
                                                        value
                                                            ? Promise.resolve()
                                                            : Promise.reject(
                                                                "Please click on checkbox to continue."
                                                            ),
                                                },
                                            ]}
                                        >
                                            <span className="mb-md-2 d-flex align-items-start gap-2">
                                                <Checkbox className="me-2" />
                                                <label htmlFor="terms">
                                                    I understand and agree with the{" "}

                                                    , the{" "}
                                                    <Link
                                                        aria-label="Privacy Policy"
                                                        to="/privacy-policy"
                                                        target="_blank"
                                                        className="text-primary"
                                                    >
                                                        Privacy Policy
                                                    </Link>
                                                    , the{" "}
                                                    <Link
                                                        aria-label="User Agreement"
                                                        to="/user-agreement"
                                                        target="_blank"
                                                        className="text-primary"
                                                    >
                                                        User Agreement
                                                    </Link>{" "}
                                                    and{" "}
                                                    <Link
                                                        aria-label="Terms and Conditions"
                                                        to="/terms-conditions"
                                                        target="_blank"
                                                        className="text-primary"
                                                    >
                                                        Fare Rules, Terms & Conditions
                                                    </Link>{" "}
                                                    of SuperbWorldTrip.
                                                </label>
                                            </span>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} className="mt-3">
                                        <Button
                                            htmlType="submit"
                                            className="btn-primary px-4 text-center rounded text-white border-0 d-md-block d-none fs-6"
                                            aria-label="Pay now"
                                        >
                                            Pay Now
                                        </Button>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>

                        <Col md={8} xs={24}>
                            <div className="sticky-cls-top">
                                <div className="card d-md-block d-none">
                                    <div className="card-body">
                                        <>
                                            {/* <h3 className="mb-3 fw-bold"></h3> */}
                                            <h3
                                                className="fw-bold mb-0 d-flex align-items-center justify-content-between"
                                                style={{ cursor: "pointer" }}
                                                onClick={togglePayment}
                                            >
                                                Payment Detail
                                            </h3>
                                            <div>
                                                {isLoading ? (
                                                    <div className="pt-3 pb-4">
                                                        <Skeleton active paragraph={{ rows: 4 }} title={false} />
                                                        <div className="text-center mt-3 bg-light p-2 rounded">
                                                            <h4 className="text-muted">Updating price details...</h4>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <div className="d-flex align-items-center justify-content-between mt-3">
                                                            <Text>
                                                                Base Fare * {nights} Night{nights > 1 ? 's' : ''}
                                                            </Text>
                                                            <Text>
                                                                <b>₹{baseFare} /-</b>
                                                            </Text>
                                                        </div>

                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <Text>{applyDiscountShow ? 'Discount' : 'Total Discount'}</Text>
                                                            <Text>
                                                                <b>
                                                                    <span className="text-danger">₹{discount}</span> /-
                                                                </b>
                                                            </Text>
                                                        </div>

                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <Text>Price after Discount</Text>
                                                            <Text>
                                                                <b>₹{publishedPrice} /-</b>
                                                            </Text>
                                                        </div>

                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <Text>Taxes & Fees</Text>
                                                            <Text>
                                                                <b>₹{serviceTax} /-</b>
                                                            </Text>
                                                        </div>

                                                        <div className="text-center mt-3 bg-light-success p-2 rounded">
                                                            <h3 className="d-flex justify-content-between">
                                                                Total: <span className="fw-bold">₹{totalAmount}</span>
                                                            </h3>
                                                        </div>

                                                        <div className="mt-4 border-0">
                                                            <Button
                                                                htmlType="submit"
                                                                className="btn-primary px-4 full-width text-center rounded text-white border-0 fs-6 py-2 d-block"
                                                                aria-label="pay now"
                                                            >
                                                                Pay Now
                                                            </Button>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </>
                                    </div>
                                </div>
                                <div className='footer-price d-md-none'>
                                    <div className='footer-price-content'>
                                        {loading ? (
                                            <div className="d-flex align-items-center gap-2">
                                                <div className="spinner"></div>
                                            </div>
                                        ) : (
                                            <>
                                                <div>
                                                    <h2 className="fw-bold d-flex align-items-center gap-2">
                                                        ₹{hotelReviewTripjack?.hInfo?.ops?.[0]?.totalFare}
                                                        <Popover
                                                            content={
                                                                <div>
                                                                    {hotelReviewTripjack?.hInfo?.ops?.[0]?.TotalPublishFare !== 0 ?
                                                                        <>
                                                                            <div>
                                                                                <div className="d-flex align-items-center justify-content-between">
                                                                                    <Text>Base Fare * {nights} Night{nights > 1 ? "s" : ""}: </Text>
                                                                                    <Text><b>₹{hotelReviewTripjack?.hInfo?.ops?.[0]?.TotalPublishFare}{''}/-</b></Text>
                                                                                </div>
                                                                                <div className="d-flex align-items-center justify-content-between">
                                                                                    <Text>Total Discount: </Text>
                                                                                    <Text><b className='text-danger'>₹{Math.round(hotelReviewTripjack?.hInfo?.ops?.[0]?.discountAmount)}/-</b></Text>
                                                                                </div>
                                                                                <div className="d-flex align-items-center justify-content-between">
                                                                                    <Text>Price after Discount: </Text>
                                                                                    <Text className='ms-1'><b>₹{Math.round(hotelReviewTripjack?.hInfo?.ops?.[0]?.PublishedPriceRoundedOff * totalRooms)}/-</b></Text>
                                                                                </div>
                                                                                <div className="d-flex align-items-center justify-content-between">
                                                                                    <Text>Taxes & Fees: </Text>
                                                                                    <Text><b>₹{Math.round(hotelReviewTripjack?.hInfo?.ops?.[0]?.ServiceTax * totalRooms)}/-</b></Text>
                                                                                </div>
                                                                            </div>
                                                                        </>

                                                                        :
                                                                        <>
                                                                            <div className='bg-light-primary p-2 rounded'>
                                                                                <div className="d-flex align-items-center justify-content-between">
                                                                                    <Text>Base Fare: </Text>
                                                                                    <Text>₹{Math.round(hotelReviewTripjack?.hInfo?.ops?.[0]?.PublishedPriceRoundedOff * totalRooms)}/-</Text>
                                                                                </div>
                                                                                <hr />
                                                                                <div className="d-flex align-items-center justify-content-between">
                                                                                    <Text>Taxes & Fees: </Text>
                                                                                    <Text>₹{Math.round(nights * hotelReviewTripjack?.hInfo?.ops?.[0]?.ServiceTax * totalRooms)}/-</Text>
                                                                                </div>
                                                                            </div>

                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <Text>Redeem: </Text>
                                                                                <Checkbox onChange={handleChange} checked={isReedom}>
                                                                                    Redeem Discount
                                                                                </Checkbox>
                                                                            </div>

                                                                            <div className="d-flex justify-content-between align-items-center my-2">
                                                                                <p className="text-muted mb-0"></p>
                                                                                <p className="mb-0 fw-bold text-success" style={{ fontSize: "1.2rem" }}>

                                                                                </p>
                                                                            </div>
                                                                        </>
                                                                    }
                                                                    <div className="text-center mt-2 bg-light-success p-1 rounded">
                                                                        <h3 className='d-flex justify-content-between'>Total Price:
                                                                            <span className='ms-1 fw-bold'>
                                                                                ₹{Math.round(
                                                                                    (hotelReviewTripjack?.hInfo?.ops?.[0]?.PublishedPriceRoundedOff * totalRooms || 0) +
                                                                                    (hotelReviewTripjack?.hInfo?.ops?.[0]?.ServiceTax * totalRooms || 0)
                                                                                )}
                                                                            </span>
                                                                        </h3>
                                                                    </div>
                                                                </div>
                                                            }
                                                            title="Payment Detail"
                                                            trigger="click"
                                                            open={open}
                                                            onOpenChange={handleOpenChange}
                                                            className="booking-filter"
                                                        >
                                                            <span><FaInfoCircle /></span>
                                                        </Popover>
                                                    </h2>
                                                    <p>
                                                        {totalRooms} Room{totalRooms > 1 ? "s" : ""}
                                                        &nbsp;For
                                                        {(() => {
                                                            const adults = totalNOAdults || 0;
                                                            const children = totalNOChildren || 0;
                                                            const totalGuest = adults + children;
                                                            return ` ${totalGuest} `;
                                                        })()}
                                                        Guest
                                                    </p>

                                                </div>
                                            </>
                                        )}


                                        <Button
                                            htmlType="submit"
                                            className="btn bg-light-primary d-inline-block float-end rounded my-3 px-4 fw-bold fs-6 py-2"
                                            aria-label="pay now"
                                        >
                                            Pay Now
                                        </Button>
                                    </div>
                                </div>

                                <HotelOffers
                                    appliedCheckLogin={appliedCheckLogin}
                                    setAppliedCheckLogin={setAppliedCheckLogin}
                                    applyDiscount={applyDiscount}
                                    totalAfterDiscount={totalAfterDiscount}
                                    setApplyDiscountShow={setApplyDiscountShow}
                                    applyDiscountShow={applyDiscountShow}
                                    isCongratulations={isCongratulations}
                                    setIsCongratulations={setIsCongratulations}
                                    isValidCoupon={isValidCoupon}
                                    setValidCoupon={setValidCoupon}
                                />
                            </div>


                        </Col>



                    </Row>

                </Form>



                <Modal
                    className="Gallery_cntr p-3"
                    open={bookingLoader}
                    footer={null}
                    onCancel={() => { setBookingLoader(false), setBookingMessageError(false); }}
                    centered
                    destroyOnClose={true}
                    width={400}
                >
                    {!bookingMessageError ? (
                        <div className="text-center py-5">
                            <img
                                loading="lazy"
                                src={flightLoader}
                                style={{ height: "100px", width: "100px" }}
                                alt="loader"
                            />
                            <h4>Loading ...</h4>
                        </div>
                    ) : (
                        <div className="text-center py-5">
                            <h4 style={{ color: "red" }}>{bookingMessage}</h4>
                        </div>
                    )}
                </Modal>

            </section>
        </>
    );
};

export default HotelPaymentTripjack;